export default __webpack_public_path__ + "static/silence-aedd80d5373c295d18b0e7f2ba2b8ebc.png";